// Admin overview (backend §58).
import { html } from '../../lib/dom';
import { pageHead, kpi, status, table, empty } from '../../components/ui';
import { columnChart, bindCharts } from '../../components/chart';
import { icon } from '../../components/icons';
import { overview, dailyCost, failedRuns, queueCounts } from '../../api/admin';
import { db } from '../../api/core';
import { money, num, relTime, shortDate } from '../../lib/format';

export function render() {
  const o = overview();
  const days = dailyCost(14);
  const failed = failedRuns().slice(0, 4);
  const q = queueCounts();

  const body = html`<div class="page">
    ${pageHead({ eyebrow: 'Platform admin', title: 'Overview', lede: 'Health of the whole platform across all organizations. Visible only to platform_admin.' })}
    <div class="grid c3">
      ${kpi('Active organizations', num(o.activeOrganizations), `${db.organizations.length} total`)}
      ${kpi('Active users', num(o.activeUsers))}
      ${kpi('Runs today', num(o.runsToday))}
      ${kpi('Running jobs', num(o.runningJobs))}
      ${kpi('Failed runs', num(o.failedRuns), 'last 30 days')}
      ${kpi('Queue size', num(o.queueSize), 'waiting + delayed')}
      ${kpi('Provider errors', num(o.providerErrors), 'providers not healthy')}
      ${kpi('Cost today', money(o.costToday))}
      ${kpi('Cost this month', money(o.costMonth))}
    </div>
    <div class="split">
      <section class="card pad-lg">${columnChart(days.map((d?: any) => ({ label: shortDate(d.day), value: d.cost })), { title: 'Internal cost per day — Bots & Bones tenant, last 14 days', fmt: (v?: any) => money(v), id: 'cost14' })}</section>
      <section class="card pad col" style="gap:6px">
        <div class="row"><h3>Providers</h3><span class="spacer"></span><a class="mono" style="font-size:11px;color:var(--fern)" href="#/admin/providers">All →</a></div>
        ${db.providers.map((p?: any) => html`<a class="list-row" href="#/admin/providers/${p.id}"><span class="t" style="flex:1">${p.name}</span>${status(p.status === 'partial_outage' ? 'partial' : p.status, p.status === 'partial_outage' ? 'Partial outage' : undefined)}</a>`)}
      </section>
    </div>
    <div class="grid c2" style="align-items:start">
      <section class="card pad"><div class="row" style="margin-bottom:6px"><h3>Latest failures</h3><span class="spacer"></span><a class="mono" style="font-size:11px;color:var(--fern)" href="#/admin/failed-runs">All →</a></div>
        ${failed.length ? table([
          { label: 'Run', mono: true, render: (f?: any) => `#${f.run.number}` },
          { label: 'Flow / node', render: (f?: any) => html`<div class="col" style="gap:0"><span>${f.flow.name}</span><span class="muted" style="font-size:12px">${f.node?.name}</span></div>` },
          { label: 'Error', mono: true, render: (f?: any) => f.nodeRun?.error?.code },
          { label: 'When', render: (f?: any) => relTime(f.run.created_at) },
        ], failed, { rowHref: (f?: any) => `#/admin/runs/${f.run.id}` }) : empty('No failures')}</section>
      <section class="card pad"><div class="row" style="margin-bottom:10px"><h3>Queue</h3><span class="spacer"></span><a class="mono" style="font-size:11px;color:var(--fern)" href="#/admin/queue">Open →</a></div>
        <div class="grid c3">${Object.entries(q).map(([k, v]: any) => html`<a class="card pad col" href="#/admin/queue?status=${k === 'completed' ? '' : k}" style="gap:4px"><span class="eyebrow">${k}</span><span style="font-size:22px">${num(v)}</span></a>`)}</div>
        <div class="banner info" style="margin-top:12px">${icon('cpu')}<div>${db.workers.filter((w?: any) => w.status === 'offline').length} worker offline · ${db.workers.filter((w?: any) => w.status === 'busy').length} busy</div></div></section>
    </div>
  </div>`;
  return { title: 'Admin · Overview', body, mount: (root?: any) => bindCharts(root) };
}
